import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { FC } from "react";
import { MdsPanelHeader } from "@/design-system/components/panel-header";
import { MdsIconKind } from "@/design-system/components/icon";

export const IntegrationsPageHeader: FC = observer(() => {
  return (
    <Wrapper>
      <MdsPanelHeader heading="Integrations" icon={MdsIconKind.BoltOutline} />
    </Wrapper>
  );
});

const Wrapper = styled.div(() => ({}));
